export default {
  "surveyQuestionnaire": "Survey",
  "satisfactionQuestionnaire": "Satisfaction survey",
  "questionnaireDashboardMaster": "Dashboard shows satisfaction indicators, trends, and periodic changes.",
  "questionnaireDashboard": "Dashboard",
  "theCEndUserHas": "User questionnaires are recorded in the question list. View response records for all questionnaires.",
  "questionnaireList": "Questionnaire List",
  "regardingSatisfaction": "AiSee supports single or multiple choice tags for satisfaction surveys, helping you quickly cite on the app.",
  "questionnaireSettings": "Settings",
  "variousContentTypes": "Content types comparison {val1}",
  "contrast": "Contrast",
  "satisfactionRate": "Satisfaction rate",
  "satisfactionScore": "Satisfaction score",
  "zhencaiAudiovisual": "Zhencai Audiovisual by Content Type",
  "eachNetworkNe": "Networks comparison {val1}",
  "zhencaiAudiovisual2": "Zhencai Audiovisual by Network",
  "gearType": "Gear type",
  "variousGearModels": "Device models comparison {val1}",
  "zhencaiAudiovisual3": "Zhencai Audiovisual by Model",
  "satisfactionRateTrend": "Satisfaction rate trend",
  "satisfactionScore2": "Satisfaction score trend",
  "zhencaiAudiovisualWorks": "What are the advantages and disadvantages of Zhencai Audiovisual as the top standard of Tencent Video Audiovisual?",
  "interfaceRequestExceeded": "Request timeout",
  "positive": "Positive",
  "zhencaiAudiovisual4": "Zhencai Audiovisual",
  "nameb": "{val1}:<br/>Zhencai Audiovisual: {val2}%<br/>All: {val3}%",
  "nameb2": "{val1}:<br/>Zhencai Audiovisual: {val2}<br/>All: {val3}",
  "zhencai": "Zhencai",
  "risingFalling": "Rising-falling",
  "documentary": "Documentary",
  "aJuvenile": "Juvenile",
  "comic": "Comic",
  "film": "Film",
  "variety": "Variety",
  "tvPlay": "TV play",
  "emptyValue": "Empty",
  "resetSuccessful": "Reset successful",
  "contentCategory": "Content category",
  "enterThePremiereYear": "Enter premiere year",
  "enterCid": "Enter CID title",
  "cidFeedback": "CID feedback frequency, satisfaction score, and satisfaction data (top 30 by default)",
  "cidFeedback2": "CID feedback frequency, satisfaction score, and satisfaction data.xlsx",
  "premiereYear": "Premiere year",
  "cidFeedback3": "CID feedback frequency",
  "cidTitle": "CID Title",
  "membershipType": "Membership type",
  "selectQuestionnaire": "Select questionnaire",
  "surve": "{val1}- {val2} {val3}- {val4}",
  "naturalMonth": "Natural Month",
  "naturalWeek": "Natural Week",
  "noMemberInformationAvailable": "No membership information",
  "nonMemberUsers": "Non-member users",
  "memberUsers": "Member users",
  "allUsers": "All users",
  "empty": "Empty",
  "clearingTimeInto": "Time cleared",
  "selectedTime": "Selected time:",
  "timeFrame": "Time frame",
  "customTime": "Custom Time",
  "goCreateANewQuestionnaire": "Create questionnaire",
  "currentlyUnavailable": "No questionnaires available",
  "generalLabel": "General",
  "percentageCalculation": "Percentage = tag feedback under \"general\" / total feedback under \"general\"",
  "notVeryGoodLabel": "Not very good",
  "percentageCalculation2": "Percentage = tag feedback under \"not very good\" / total feedback under \"not very good\"",
  "justSoSo": "Just so so",
  "veryGoodLabel": "Very good",
  "percentageCalculation3": "Percentage = tag feedback under \"Very Good\" / total feedback under \"Very Good\"",
  "veryGood": "Very good",
  "problemFeedbackLabel": "The problem? (Label Statistics)",
  "userFeedback": "Users provided feedback on main issues",
  "percentage": "Percentage",
  "quantity": "Quantity",
  "label": "Label",
  "secondaryLabelSystem": "Secondary Label Statistics",
  "correspondingToTheSelectedTime": "Satisfaction score change vs. previous period",
  "theScoringOptionsAreVeryGood": "\"Very good\" accounts for % of total, \"not very good\" accounts for % of total",
  "correspondingToTheSelectedTime2": "Satisfaction rate change vs. previous period",
  "theScoringOptionsAreVeryGood2": "\"Very good\" / Total * 100%",
  "correspondingToTheSelectedTime3": "Respondents change vs. previous period",
  "numberOfRespondents": "Respondents",
  "questionnaireSubmission": "Questionnaire received a satisfactory vote.",
  "theQuestionnaireIncludes": "Questionnaire including",
  "thisCycleHasATotalOf": "Total collected this cycle",
  "aFeedbackQuestionnaire": "Feedback questionnaire.",
  "thisQuestionnaireWasCreated": "Total responses received since creation",
  "since": "Since",
  "howManyUsersAreThere": "How many users cast a satisfied vote?",
  "numberOfSatisfiedIndividuals": "Satisfied individuals distribution.xlsx",
  "numberOfPeople": "Number of people",
  "percentageCalculation4": "Percentage = feedback options / total feedback",
  "theFeedbackQuestionnaire": "Feedback questionnaire.",
  "targetingTencent": "Regarding Tencent Video",
  "sinceThenThereHaveBeenATotalOfResponses": "Total responses since then",
  "whatHaveYouExperienced": "What changes have you experienced?",
  "trend": "{val1}.xlsx",
  "playerFunction": "Player experience",
  "soundAndPictureQualityExperience": "Audio/video quality",
  "tencentVideo": "Tencent Video overall experience",
  "forma": "{val1} million",
  "dissatisfied": "😡  dissatisfied",
  "veryDissatisfied": "Very dissatisfied",
  "dissatisfied2": "Dissatisfied",
  "commonly": "😑  commonly",
  "generallySatisfied": "Generally satisfied",
  "satisfied": "😁  satisfied",
  "verySatisfied": "Very satisfied",
  "satisfied2": "Satisfied",
  "enterVid": "Enter VID title",
  "vidFeedback": "VID feedback frequency, satisfaction score, and satisfaction data (top 30 by default)",
  "vidFeedback2": "VID feedback frequency, satisfaction score, and satisfaction data.xlsx",
  "vidFeedback3": "VID feedback frequency",
  "vidTitle": "VID Title",
  "scoringOptions": "Scoring options",
  "belongingQuestionnaire": "Questionnaire",
  "channelName": "Channel Name",
  "dataExportInProgress": "Exporting...",
  "allQuestionnaires": "All questionnaires",
  "surve2": "{val1}- {val2}{val3}",
  "exportCurrentFilter": "Export filtered data",
  "confirmExportIsFull": "Export satisfaction data? (Max 40000 per export)",
  "popUpNotification": "Notification",
  "pleaseChooseAChannel": "Please choose a channel",
  "questionnaireChannel": "Channel",
  "questionnaireTitle": "Title",
  "channelDescription": "Description",
  "pleaseEnterTheChannel": "Enter channel name",
  "pleaseFillInTheChannel": "Enter channel name",
  "newChannel": "New channel",
  "creationFailedPlease": "Creation failed, please try again",
  "modificationFailedPlease": "Modification failed, please try again",
  "deleteFailedPlease": "Delete failed, please try again",
  "areYouSureYouWantToDelete": "Delete this channel? (Cannot be restored)",
  "updatedBy": "Updated by",
  "channelId": "Channel ID",
  "createANewQuestionnaire": "Create questionnaire",
  "editQuestionnaire": "Edit questionnaire",
  "pleaseFillInTheI": "Enter scene value for {val1}th distribution scenario",
  "pleaseFillInTheI2": "Enter name for {val1}th distribution scenario",
  "pleaseSelectAtLeast": "Select at least two options",
  "pleaseFillInTheI3": "Enter title for {val1}th scoring option",
  "pleaseSelectAQuestionnaire": "Select questionnaire type",
  "pleaseFillOutTheQuestionnaire": "Enter questionnaire title",
  "pleaseSelectAQuestionnaire2": "Select channel",
  "pleaseChooseNext": "Select next questionnaire",
  "nextQuestionnaire": "Next questionnaire",
  "multipleChoice": "Multiple Choice",
  "tagType": "Tag type",
  "addTags": "Add tags",
  "addedSuccessfully": "Added successfully",
  "pleaseSelectALabel": "Select a label",
  "tagContent": "Tag content",
  "labelIssue": "Label issue",
  "pleaseEnterTheQuestion": "Enter the question",
  "pleaseClickOnMultilingual": "Click multilingual button to input option questions",
  "optionsIcon": "Options icon",
  "optionName": "Option Name",
  "pleaseEnterOptions": "Enter option name",
  "pleaseClickOnMultilingual2": "Click multilingual button to enter option name",
  "editTags": "Edit tags",
  "icon": "Icon",
  "textIcon": "Text+icon",
  "writtenWords": "Text",
  "optionType": "Option type",
  "option": "Option",
  "singleChoiceQuestion": "Single Choice",
  "multipleChoiceQuestions": "Multiple Choice",
  "subject": "Subject",
  "pleaseEnterTheQuestion2": "Enter the question",
  "pleaseClickOnMultilingual3": "Click multilingual button to enter question",
  "titleInd": "Title {val1}",
  "secondaryLabel": "Secondary label",
  "firstLevelLabel": "First level label",
  "chooseToFillInTheSecondLevelBid": "Optional: secondary tag group title",
  "optionalConfiguration2": "Optional: secondary tag is a sub-tag under questionnaire tag",
  "addDistributionField": "Add distribution scenario",
  "enterDistributionField": "Enter scenario and press Enter",
  "sceneValue": "Scene value",
  "sceneNameOnly": "Scene names: English only",
  "pleaseEnterAndDistribute": "Enter scene name",
  "sceneName": "Scene name",
  "optionalConfiguration": "Optional: questionnaire only issued when requested scenario exists. (Keep at least one)",
  "distributionScenario": "Distribution scenario",
  "newTopic": "New Topic",
  "sortItemI": "Scoring option {val1}",
  "titleInd2": "Title {val1}",
  "reduceTheScoreSystemMeeting": "Shrinking scale will lose data from excess scales. Continue?",
  "questionnaireType": "Questionnaire type",
  "pleaseEnterTheQuestionnaire": "Enter questionnaire title",
  "pleaseClickOnMultilingual4": "Click multilingual button to enter title",
  "tagDescription": "Tag description",
  "enableMultipleLanguages": "After enabling, background language is English",
  "questionnaireId": "Questionnaire ID",
  "open": "Open",
  "fivePointSystem": "Five point",
  "threePointSystem": "Three point",
  "binarySystem": "Binary",
  "optionTypesAnd": "Option type and option don't match, please select again",
  "changeStatusLost": "Failed to modify status, please try again",
  "changeTheStatusTo": "Status modified",
  "confirmToCloseTheQuestion": "Close questionnaire?",
  "confirmToOpenTheQuestion": "Open questionnaire?",
  "openStatus": "Open status",
  "channelSettings": "Channel Settings"
}